import { useTranslation } from '../../../hooks';
import { useProfileQueryContext } from '../../../contexts/demographicInsights';
import { InsightTable } from './InsightTable';

export const EmailDomainsTable = () => {
  const { t } = useTranslation();
  const { emailDomains } = useProfileQueryContext();
  const title = t('insights.emailDomains');
  const values = emailDomains ?? [];

  return <InsightTable title={title} values={values} showDivider isEnabled={!!values.length} />;
};
